<template>
  <div
    class="incrediToggle row gordita-500-11"
    :class="{ disabled }"
  >
    <div
      :class="{ 'toggle-on': toggleValue === true, grow }"
      class="toggle-button incrediToggle-button-left"
      @click="handleToggle(true)"
    >
      {{ toggleOnText }}
    </div>
    <div
      :class="{ 'toggle-on': toggleValue === false, grow }"
      class="toggle-button incrediToggle-button-right"
      @click="handleToggle(false)"
    >
      {{ toggleOffText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'IncrediToggle',
  props: {
    toggleOnText: {
      type: String,
    },
    toggleOffText: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultToggleValue: {
      type: Boolean,
      default: undefined,
    },
    grow: {
      type: Boolean,
      Default: false,
    },
  },
  emits: ['update:modelValue', 'input'],
  data() {
    return {
      toggle: undefined,
    };
  },
  computed: {
    toggleValue() {
      return this.toggle ?? this.defaultToggleValue;
    },
  },
  created() {
    this.toggle = this.defaultToggleValue;
  },
  methods: {
    handleToggle(value) {
      this.toggle = value;
      this.$emit('input', value);
      this.$emit('update:modelValue', value);
    },
  },
};
</script>

<style scoped lang="scss">
.incrediToggle-button-left {
  border-radius: 2px 0px 0px 2px;
}
.incrediToggle-button-right {
  margin-left: -1px;
  border-radius: 0px 2px 2px 0px;
}

.incrediToggle {
  &.disabled {
    pointer-events: none;
    cursor: not-allowed;
    .toggle-button {
      background-color: $-system-app-white;
      color: $-text-text-lowest;
      border: 1px solid $-system-app-border;

      &.toggle-on {
        background-color: $-system-app-background;
        border: 1px solid $-system-app-border;
        color: $-text-text-lowest;
      }
    }
  }
}

.toggle-button {
  width: 80px;
  padding: 7px 0;
  text-align: center;
  background-color: white;
  border: 1px solid $-text-text-low-old;
  color: $-text-text-medium;
  cursor: default;

  &:hover {
    border: 1px solid $-text--dark;
    color: $-text--dark;
    z-index: 2;
    &:not(.toggle-on) {
      cursor: pointer;
    }
  }

  &.toggle-on {
    background-color: $-hovers-hover-primary;
    border: 1px solid $-text-text-primary;
    color: $-text-text-primary;
    z-index: 1;
    cursor: initial;

    &:hover {
      background-color: $-hovers-hover-primary;
      border: 1px solid $-text-text-primary;
    }
  }
}
</style>
